import { ApiDtoModel } from '@siza-staff-care/shared/data';

export const Max_Integer = Math.pow(2, 31) - 1;

// https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid
export const generateUUID = () => {
	let d = new Date().getTime(),
		d2 = (performance && performance.now && performance.now() * 1000) || 0;
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
		let r = Math.random() * 16;
		if (d > 0) {
			r = (d + r) % 16 | 0;
			d = Math.floor(d / 16);
		} else {
			r = (d2 + r) % 16 | 0;
			d2 = Math.floor(d2 / 16);
		}
		return (c == 'x' ? r : (r & 0x7) | 0x8).toString(16);
	});
};

/**
 * Takes a DTO object and ensures that the $type property is the first property in the object, as required by Jade's REST processing.
 * Optionally takes a setType parameter to override the $type property.
 * @param dto The DTO to use
 * @param setType The optional $type to use if $type isn't already set on the DTO.
 * @returns
 */
export const ensureTypeSetAsFirstProp = <T extends ApiDtoModel>(dto: T | undefined, setType = ''): T | undefined => {
	if (!dto) {
		return undefined;
	}

	const type = dto.$type || setType;
	const partial = dto as Partial<T>;
	delete partial.$type;
	return { $type: type, ...partial } as T;
};
